import { default as _91type_93UbIQ9D2satMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue?macro=true";
import { default as batch_45qr_45codekBI0ykSRJEMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue?macro=true";
import { default as contact_45usIb7MRRSVQxMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue?macro=true";
import { default as indexlv6uwoMeKuMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue?macro=true";
import { default as acceptable_45use_45policys9pdy8cAtHMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue?macro=true";
import { default as cookies_45policyEjmYNtj1HuMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue?macro=true";
import { default as data_45processing_45agreenentJUVGdgpiu1Meta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue?macro=true";
import { default as legal_45noticebEomHJ5f4SMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue?macro=true";
import { default as privacy_45policywJEsf280RvMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue?macro=true";
import { default as terms_45of_45conditionsAUnb6nPDrjMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue?macro=true";
import { default as pricingqByXFTYxiPMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue?macro=true";
import { default as _91slug_93UpYsbtF76BMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue?macro=true";
import { default as qr_45code_45scannerZMcQpP9gxxMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue?macro=true";
import { default as qr_45codes_45for_45nonprofitDYzw8aaZWIMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue?macro=true";
import { default as qr_45codes_45for_45personalnrvPp8IgfaMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue?macro=true";
import { default as qr_45codes_45forsiKtTDHadyMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue?macro=true";
import { default as qr_45codes_45in_45educationFDYFjxWr4QMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue?macro=true";
import { default as qr_45codes_45in_45marketinglKuTbH5bBIMeta } from "D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue?macro=true";
export default [
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___en___default",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___en",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/en/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___vi",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/vi/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___de",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/de/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___es",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/es/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___fr",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/fr/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___it",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/it/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___ja",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/ja/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___nl",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/nl/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___pt",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/pt/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___zh",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/zh/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___tr",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/tr/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___id",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/id/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___hi",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/hi/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93UbIQ9D2satMeta?.name ?? "type___th",
    path: _91type_93UbIQ9D2satMeta?.path ?? "/th/:type",
    children: [],
    meta: _91type_93UbIQ9D2satMeta || {},
    alias: _91type_93UbIQ9D2satMeta?.alias || [],
    redirect: _91type_93UbIQ9D2satMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/[type].vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___en___default",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/batch-qr-code",
    children: [],
    url: "/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___en",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/en/batch-qr-code",
    children: [],
    url: "/en/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___vi",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/vi/batch-qr-code",
    children: [],
    url: "/vi/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___de",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/de/batch-qr-code",
    children: [],
    url: "/de/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___es",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/es/batch-qr-code",
    children: [],
    url: "/es/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___fr",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/fr/batch-qr-code",
    children: [],
    url: "/fr/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___it",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/it/batch-qr-code",
    children: [],
    url: "/it/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___ja",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/ja/batch-qr-code",
    children: [],
    url: "/ja/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___nl",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/nl/batch-qr-code",
    children: [],
    url: "/nl/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___pt",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/pt/batch-qr-code",
    children: [],
    url: "/pt/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___zh",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/zh/batch-qr-code",
    children: [],
    url: "/zh/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___tr",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/tr/batch-qr-code",
    children: [],
    url: "/tr/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___id",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/id/batch-qr-code",
    children: [],
    url: "/id/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___hi",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/hi/batch-qr-code",
    children: [],
    url: "/hi/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: batch_45qr_45codekBI0ykSRJEMeta?.name ?? "batch-qr-code___th",
    path: batch_45qr_45codekBI0ykSRJEMeta?.path ?? "/th/batch-qr-code",
    children: [],
    url: "/th/batch-qr-code",
    meta: batch_45qr_45codekBI0ykSRJEMeta || {},
    alias: batch_45qr_45codekBI0ykSRJEMeta?.alias || [],
    redirect: batch_45qr_45codekBI0ykSRJEMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/batch-qr-code.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___en___default",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/contact-us",
    children: [],
    url: "/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___en",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/en/contact-us",
    children: [],
    url: "/en/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___vi",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/vi/contact-us",
    children: [],
    url: "/vi/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___de",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/de/contact-us",
    children: [],
    url: "/de/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___es",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/es/contact-us",
    children: [],
    url: "/es/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___fr",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/fr/contact-us",
    children: [],
    url: "/fr/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___it",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/it/contact-us",
    children: [],
    url: "/it/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___ja",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/ja/contact-us",
    children: [],
    url: "/ja/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___nl",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/nl/contact-us",
    children: [],
    url: "/nl/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___pt",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/pt/contact-us",
    children: [],
    url: "/pt/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___zh",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/zh/contact-us",
    children: [],
    url: "/zh/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___tr",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/tr/contact-us",
    children: [],
    url: "/tr/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___id",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/id/contact-us",
    children: [],
    url: "/id/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___hi",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/hi/contact-us",
    children: [],
    url: "/hi/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usIb7MRRSVQxMeta?.name ?? "contact-us___th",
    path: contact_45usIb7MRRSVQxMeta?.path ?? "/th/contact-us",
    children: [],
    url: "/th/contact-us",
    meta: contact_45usIb7MRRSVQxMeta || {},
    alias: contact_45usIb7MRRSVQxMeta?.alias || [],
    redirect: contact_45usIb7MRRSVQxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___en___default",
    path: indexlv6uwoMeKuMeta?.path ?? "/",
    children: [],
    url: "/",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___en",
    path: indexlv6uwoMeKuMeta?.path ?? "/en",
    children: [],
    url: "/en",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___vi",
    path: indexlv6uwoMeKuMeta?.path ?? "/vi",
    children: [],
    url: "/vi",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___de",
    path: indexlv6uwoMeKuMeta?.path ?? "/de",
    children: [],
    url: "/de",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___es",
    path: indexlv6uwoMeKuMeta?.path ?? "/es",
    children: [],
    url: "/es",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___fr",
    path: indexlv6uwoMeKuMeta?.path ?? "/fr",
    children: [],
    url: "/fr",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___it",
    path: indexlv6uwoMeKuMeta?.path ?? "/it",
    children: [],
    url: "/it",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___ja",
    path: indexlv6uwoMeKuMeta?.path ?? "/ja",
    children: [],
    url: "/ja",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___nl",
    path: indexlv6uwoMeKuMeta?.path ?? "/nl",
    children: [],
    url: "/nl",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___pt",
    path: indexlv6uwoMeKuMeta?.path ?? "/pt",
    children: [],
    url: "/pt",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___zh",
    path: indexlv6uwoMeKuMeta?.path ?? "/zh",
    children: [],
    url: "/zh",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___tr",
    path: indexlv6uwoMeKuMeta?.path ?? "/tr",
    children: [],
    url: "/tr",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___id",
    path: indexlv6uwoMeKuMeta?.path ?? "/id",
    children: [],
    url: "/id",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___hi",
    path: indexlv6uwoMeKuMeta?.path ?? "/hi",
    children: [],
    url: "/hi",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlv6uwoMeKuMeta?.name ?? "index___th",
    path: indexlv6uwoMeKuMeta?.path ?? "/th",
    children: [],
    url: "/th",
    meta: indexlv6uwoMeKuMeta || {},
    alias: indexlv6uwoMeKuMeta?.alias || [],
    redirect: indexlv6uwoMeKuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___en___default",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/page/acceptable-use-policy",
    children: [],
    url: "/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___en",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/en/page/acceptable-use-policy",
    children: [],
    url: "/en/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___vi",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/vi/page/acceptable-use-policy",
    children: [],
    url: "/vi/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___de",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/de/page/acceptable-use-policy",
    children: [],
    url: "/de/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___es",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/es/page/acceptable-use-policy",
    children: [],
    url: "/es/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___fr",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/fr/page/acceptable-use-policy",
    children: [],
    url: "/fr/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___it",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/it/page/acceptable-use-policy",
    children: [],
    url: "/it/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___ja",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/ja/page/acceptable-use-policy",
    children: [],
    url: "/ja/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___nl",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/nl/page/acceptable-use-policy",
    children: [],
    url: "/nl/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___pt",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/pt/page/acceptable-use-policy",
    children: [],
    url: "/pt/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___zh",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/zh/page/acceptable-use-policy",
    children: [],
    url: "/zh/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___tr",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/tr/page/acceptable-use-policy",
    children: [],
    url: "/tr/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___id",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/id/page/acceptable-use-policy",
    children: [],
    url: "/id/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___hi",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/hi/page/acceptable-use-policy",
    children: [],
    url: "/hi/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: acceptable_45use_45policys9pdy8cAtHMeta?.name ?? "page-acceptable-use-policy___th",
    path: acceptable_45use_45policys9pdy8cAtHMeta?.path ?? "/th/page/acceptable-use-policy",
    children: [],
    url: "/th/page/acceptable-use-policy",
    meta: acceptable_45use_45policys9pdy8cAtHMeta || {},
    alias: acceptable_45use_45policys9pdy8cAtHMeta?.alias || [],
    redirect: acceptable_45use_45policys9pdy8cAtHMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/acceptable-use-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___en___default",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/page/cookies-policy",
    children: [],
    url: "/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___en",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/en/page/cookies-policy",
    children: [],
    url: "/en/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___vi",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/vi/page/cookies-policy",
    children: [],
    url: "/vi/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___de",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/de/page/cookies-policy",
    children: [],
    url: "/de/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___es",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/es/page/cookies-policy",
    children: [],
    url: "/es/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___fr",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/fr/page/cookies-policy",
    children: [],
    url: "/fr/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___it",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/it/page/cookies-policy",
    children: [],
    url: "/it/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___ja",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/ja/page/cookies-policy",
    children: [],
    url: "/ja/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___nl",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/nl/page/cookies-policy",
    children: [],
    url: "/nl/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___pt",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/pt/page/cookies-policy",
    children: [],
    url: "/pt/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___zh",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/zh/page/cookies-policy",
    children: [],
    url: "/zh/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___tr",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/tr/page/cookies-policy",
    children: [],
    url: "/tr/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___id",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/id/page/cookies-policy",
    children: [],
    url: "/id/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___hi",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/hi/page/cookies-policy",
    children: [],
    url: "/hi/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: cookies_45policyEjmYNtj1HuMeta?.name ?? "page-cookies-policy___th",
    path: cookies_45policyEjmYNtj1HuMeta?.path ?? "/th/page/cookies-policy",
    children: [],
    url: "/th/page/cookies-policy",
    meta: cookies_45policyEjmYNtj1HuMeta || {},
    alias: cookies_45policyEjmYNtj1HuMeta?.alias || [],
    redirect: cookies_45policyEjmYNtj1HuMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/cookies-policy.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___en___default",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/page/data-processing-agreenent",
    children: [],
    url: "/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___en",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/en/page/data-processing-agreenent",
    children: [],
    url: "/en/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___vi",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/vi/page/data-processing-agreenent",
    children: [],
    url: "/vi/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___de",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/de/page/data-processing-agreenent",
    children: [],
    url: "/de/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___es",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/es/page/data-processing-agreenent",
    children: [],
    url: "/es/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___fr",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/fr/page/data-processing-agreenent",
    children: [],
    url: "/fr/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___it",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/it/page/data-processing-agreenent",
    children: [],
    url: "/it/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___ja",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/ja/page/data-processing-agreenent",
    children: [],
    url: "/ja/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___nl",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/nl/page/data-processing-agreenent",
    children: [],
    url: "/nl/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___pt",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/pt/page/data-processing-agreenent",
    children: [],
    url: "/pt/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___zh",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/zh/page/data-processing-agreenent",
    children: [],
    url: "/zh/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___tr",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/tr/page/data-processing-agreenent",
    children: [],
    url: "/tr/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___id",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/id/page/data-processing-agreenent",
    children: [],
    url: "/id/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___hi",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/hi/page/data-processing-agreenent",
    children: [],
    url: "/hi/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: data_45processing_45agreenentJUVGdgpiu1Meta?.name ?? "page-data-processing-agreenent___th",
    path: data_45processing_45agreenentJUVGdgpiu1Meta?.path ?? "/th/page/data-processing-agreenent",
    children: [],
    url: "/th/page/data-processing-agreenent",
    meta: data_45processing_45agreenentJUVGdgpiu1Meta || {},
    alias: data_45processing_45agreenentJUVGdgpiu1Meta?.alias || [],
    redirect: data_45processing_45agreenentJUVGdgpiu1Meta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/data-processing-agreenent.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___en___default",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/page/legal-notice",
    children: [],
    url: "/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___en",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/en/page/legal-notice",
    children: [],
    url: "/en/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___vi",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/vi/page/legal-notice",
    children: [],
    url: "/vi/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___de",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/de/page/legal-notice",
    children: [],
    url: "/de/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___es",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/es/page/legal-notice",
    children: [],
    url: "/es/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___fr",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/fr/page/legal-notice",
    children: [],
    url: "/fr/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___it",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/it/page/legal-notice",
    children: [],
    url: "/it/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___ja",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/ja/page/legal-notice",
    children: [],
    url: "/ja/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___nl",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/nl/page/legal-notice",
    children: [],
    url: "/nl/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___pt",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/pt/page/legal-notice",
    children: [],
    url: "/pt/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___zh",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/zh/page/legal-notice",
    children: [],
    url: "/zh/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___tr",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/tr/page/legal-notice",
    children: [],
    url: "/tr/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___id",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/id/page/legal-notice",
    children: [],
    url: "/id/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___hi",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/hi/page/legal-notice",
    children: [],
    url: "/hi/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: legal_45noticebEomHJ5f4SMeta?.name ?? "page-legal-notice___th",
    path: legal_45noticebEomHJ5f4SMeta?.path ?? "/th/page/legal-notice",
    children: [],
    url: "/th/page/legal-notice",
    meta: legal_45noticebEomHJ5f4SMeta || {},
    alias: legal_45noticebEomHJ5f4SMeta?.alias || [],
    redirect: legal_45noticebEomHJ5f4SMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/legal-notice.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___en___default",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/page/privacy-policy",
    children: [],
    url: "/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___en",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/en/page/privacy-policy",
    children: [],
    url: "/en/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___vi",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/vi/page/privacy-policy",
    children: [],
    url: "/vi/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___de",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/de/page/privacy-policy",
    children: [],
    url: "/de/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___es",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/es/page/privacy-policy",
    children: [],
    url: "/es/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___fr",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/fr/page/privacy-policy",
    children: [],
    url: "/fr/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___it",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/it/page/privacy-policy",
    children: [],
    url: "/it/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___ja",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/ja/page/privacy-policy",
    children: [],
    url: "/ja/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___nl",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/nl/page/privacy-policy",
    children: [],
    url: "/nl/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___pt",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/pt/page/privacy-policy",
    children: [],
    url: "/pt/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___zh",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/zh/page/privacy-policy",
    children: [],
    url: "/zh/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___tr",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/tr/page/privacy-policy",
    children: [],
    url: "/tr/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___id",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/id/page/privacy-policy",
    children: [],
    url: "/id/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___hi",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/hi/page/privacy-policy",
    children: [],
    url: "/hi/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywJEsf280RvMeta?.name ?? "page-privacy-policy___th",
    path: privacy_45policywJEsf280RvMeta?.path ?? "/th/page/privacy-policy",
    children: [],
    url: "/th/page/privacy-policy",
    meta: privacy_45policywJEsf280RvMeta || {},
    alias: privacy_45policywJEsf280RvMeta?.alias || [],
    redirect: privacy_45policywJEsf280RvMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___en___default",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/page/terms-of-conditions",
    children: [],
    url: "/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___en",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/en/page/terms-of-conditions",
    children: [],
    url: "/en/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___vi",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/vi/page/terms-of-conditions",
    children: [],
    url: "/vi/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___de",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/de/page/terms-of-conditions",
    children: [],
    url: "/de/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___es",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/es/page/terms-of-conditions",
    children: [],
    url: "/es/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___fr",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/fr/page/terms-of-conditions",
    children: [],
    url: "/fr/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___it",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/it/page/terms-of-conditions",
    children: [],
    url: "/it/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___ja",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/ja/page/terms-of-conditions",
    children: [],
    url: "/ja/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___nl",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/nl/page/terms-of-conditions",
    children: [],
    url: "/nl/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___pt",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/pt/page/terms-of-conditions",
    children: [],
    url: "/pt/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___zh",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/zh/page/terms-of-conditions",
    children: [],
    url: "/zh/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___tr",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/tr/page/terms-of-conditions",
    children: [],
    url: "/tr/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___id",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/id/page/terms-of-conditions",
    children: [],
    url: "/id/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___hi",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/hi/page/terms-of-conditions",
    children: [],
    url: "/hi/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45conditionsAUnb6nPDrjMeta?.name ?? "page-terms-of-conditions___th",
    path: terms_45of_45conditionsAUnb6nPDrjMeta?.path ?? "/th/page/terms-of-conditions",
    children: [],
    url: "/th/page/terms-of-conditions",
    meta: terms_45of_45conditionsAUnb6nPDrjMeta || {},
    alias: terms_45of_45conditionsAUnb6nPDrjMeta?.alias || [],
    redirect: terms_45of_45conditionsAUnb6nPDrjMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/page/terms-of-conditions.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___en___default",
    path: pricingqByXFTYxiPMeta?.path ?? "/pricing",
    children: [],
    url: "/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___en",
    path: pricingqByXFTYxiPMeta?.path ?? "/en/pricing",
    children: [],
    url: "/en/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___vi",
    path: pricingqByXFTYxiPMeta?.path ?? "/vi/pricing",
    children: [],
    url: "/vi/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___de",
    path: pricingqByXFTYxiPMeta?.path ?? "/de/pricing",
    children: [],
    url: "/de/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___es",
    path: pricingqByXFTYxiPMeta?.path ?? "/es/pricing",
    children: [],
    url: "/es/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___fr",
    path: pricingqByXFTYxiPMeta?.path ?? "/fr/pricing",
    children: [],
    url: "/fr/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___it",
    path: pricingqByXFTYxiPMeta?.path ?? "/it/pricing",
    children: [],
    url: "/it/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___ja",
    path: pricingqByXFTYxiPMeta?.path ?? "/ja/pricing",
    children: [],
    url: "/ja/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___nl",
    path: pricingqByXFTYxiPMeta?.path ?? "/nl/pricing",
    children: [],
    url: "/nl/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___pt",
    path: pricingqByXFTYxiPMeta?.path ?? "/pt/pricing",
    children: [],
    url: "/pt/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___zh",
    path: pricingqByXFTYxiPMeta?.path ?? "/zh/pricing",
    children: [],
    url: "/zh/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___tr",
    path: pricingqByXFTYxiPMeta?.path ?? "/tr/pricing",
    children: [],
    url: "/tr/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___id",
    path: pricingqByXFTYxiPMeta?.path ?? "/id/pricing",
    children: [],
    url: "/id/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___hi",
    path: pricingqByXFTYxiPMeta?.path ?? "/hi/pricing",
    children: [],
    url: "/hi/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingqByXFTYxiPMeta?.name ?? "pricing___th",
    path: pricingqByXFTYxiPMeta?.path ?? "/th/pricing",
    children: [],
    url: "/th/pricing",
    meta: pricingqByXFTYxiPMeta || {},
    alias: pricingqByXFTYxiPMeta?.alias || [],
    redirect: pricingqByXFTYxiPMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___en___default",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___en",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/en/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___vi",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/vi/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___de",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/de/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___es",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/es/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___fr",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/fr/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___it",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/it/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___ja",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/ja/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___nl",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/nl/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___pt",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/pt/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___zh",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/zh/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___tr",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/tr/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___id",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/id/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___hi",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/hi/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93UpYsbtF76BMeta?.name ?? "q-slug___th",
    path: _91slug_93UpYsbtF76BMeta?.path ?? "/th/q/:slug",
    children: [],
    meta: _91slug_93UpYsbtF76BMeta || {},
    alias: _91slug_93UpYsbtF76BMeta?.alias || [],
    redirect: _91slug_93UpYsbtF76BMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/q/[slug].vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___en___default",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/qr-code-scanner",
    children: [],
    url: "/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___en",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/en/qr-code-scanner",
    children: [],
    url: "/en/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___vi",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/vi/qr-code-scanner",
    children: [],
    url: "/vi/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___de",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/de/qr-code-scanner",
    children: [],
    url: "/de/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___es",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/es/qr-code-scanner",
    children: [],
    url: "/es/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___fr",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/fr/qr-code-scanner",
    children: [],
    url: "/fr/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___it",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/it/qr-code-scanner",
    children: [],
    url: "/it/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___ja",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/ja/qr-code-scanner",
    children: [],
    url: "/ja/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___nl",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/nl/qr-code-scanner",
    children: [],
    url: "/nl/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___pt",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/pt/qr-code-scanner",
    children: [],
    url: "/pt/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___zh",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/zh/qr-code-scanner",
    children: [],
    url: "/zh/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___tr",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/tr/qr-code-scanner",
    children: [],
    url: "/tr/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___id",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/id/qr-code-scanner",
    children: [],
    url: "/id/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___hi",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/hi/qr-code-scanner",
    children: [],
    url: "/hi/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45code_45scannerZMcQpP9gxxMeta?.name ?? "qr-code-scanner___th",
    path: qr_45code_45scannerZMcQpP9gxxMeta?.path ?? "/th/qr-code-scanner",
    children: [],
    url: "/th/qr-code-scanner",
    meta: qr_45code_45scannerZMcQpP9gxxMeta || {},
    alias: qr_45code_45scannerZMcQpP9gxxMeta?.alias || [],
    redirect: qr_45code_45scannerZMcQpP9gxxMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-code-scanner.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___en___default",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/qr-codes-for-nonprofit",
    children: [],
    url: "/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___en",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/en/qr-codes-for-nonprofit",
    children: [],
    url: "/en/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___vi",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/vi/qr-codes-for-nonprofit",
    children: [],
    url: "/vi/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___de",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/de/qr-codes-for-nonprofit",
    children: [],
    url: "/de/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___es",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/es/qr-codes-for-nonprofit",
    children: [],
    url: "/es/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___fr",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/fr/qr-codes-for-nonprofit",
    children: [],
    url: "/fr/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___it",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/it/qr-codes-for-nonprofit",
    children: [],
    url: "/it/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___ja",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/ja/qr-codes-for-nonprofit",
    children: [],
    url: "/ja/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___nl",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/nl/qr-codes-for-nonprofit",
    children: [],
    url: "/nl/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___pt",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/pt/qr-codes-for-nonprofit",
    children: [],
    url: "/pt/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___zh",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/zh/qr-codes-for-nonprofit",
    children: [],
    url: "/zh/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___tr",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/tr/qr-codes-for-nonprofit",
    children: [],
    url: "/tr/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___id",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/id/qr-codes-for-nonprofit",
    children: [],
    url: "/id/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___hi",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/hi/qr-codes-for-nonprofit",
    children: [],
    url: "/hi/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.name ?? "qr-codes-for-nonprofit___th",
    path: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.path ?? "/th/qr-codes-for-nonprofit",
    children: [],
    url: "/th/qr-codes-for-nonprofit",
    meta: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta || {},
    alias: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.alias || [],
    redirect: qr_45codes_45for_45nonprofitDYzw8aaZWIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-nonprofit.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___en___default",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/qr-codes-for-personal",
    children: [],
    url: "/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___en",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/en/qr-codes-for-personal",
    children: [],
    url: "/en/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___vi",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/vi/qr-codes-for-personal",
    children: [],
    url: "/vi/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___de",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/de/qr-codes-for-personal",
    children: [],
    url: "/de/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___es",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/es/qr-codes-for-personal",
    children: [],
    url: "/es/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___fr",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/fr/qr-codes-for-personal",
    children: [],
    url: "/fr/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___it",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/it/qr-codes-for-personal",
    children: [],
    url: "/it/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___ja",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/ja/qr-codes-for-personal",
    children: [],
    url: "/ja/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___nl",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/nl/qr-codes-for-personal",
    children: [],
    url: "/nl/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___pt",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/pt/qr-codes-for-personal",
    children: [],
    url: "/pt/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___zh",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/zh/qr-codes-for-personal",
    children: [],
    url: "/zh/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___tr",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/tr/qr-codes-for-personal",
    children: [],
    url: "/tr/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___id",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/id/qr-codes-for-personal",
    children: [],
    url: "/id/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___hi",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/hi/qr-codes-for-personal",
    children: [],
    url: "/hi/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45for_45personalnrvPp8IgfaMeta?.name ?? "qr-codes-for-personal___th",
    path: qr_45codes_45for_45personalnrvPp8IgfaMeta?.path ?? "/th/qr-codes-for-personal",
    children: [],
    url: "/th/qr-codes-for-personal",
    meta: qr_45codes_45for_45personalnrvPp8IgfaMeta || {},
    alias: qr_45codes_45for_45personalnrvPp8IgfaMeta?.alias || [],
    redirect: qr_45codes_45for_45personalnrvPp8IgfaMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for-personal.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___en___default",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/qr-codes-for",
    children: [],
    url: "/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___en",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/en/qr-codes-for",
    children: [],
    url: "/en/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___vi",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/vi/qr-codes-for",
    children: [],
    url: "/vi/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___de",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/de/qr-codes-for",
    children: [],
    url: "/de/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___es",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/es/qr-codes-for",
    children: [],
    url: "/es/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___fr",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/fr/qr-codes-for",
    children: [],
    url: "/fr/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___it",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/it/qr-codes-for",
    children: [],
    url: "/it/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___ja",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/ja/qr-codes-for",
    children: [],
    url: "/ja/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___nl",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/nl/qr-codes-for",
    children: [],
    url: "/nl/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___pt",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/pt/qr-codes-for",
    children: [],
    url: "/pt/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___zh",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/zh/qr-codes-for",
    children: [],
    url: "/zh/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___tr",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/tr/qr-codes-for",
    children: [],
    url: "/tr/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___id",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/id/qr-codes-for",
    children: [],
    url: "/id/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___hi",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/hi/qr-codes-for",
    children: [],
    url: "/hi/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45forsiKtTDHadyMeta?.name ?? "qr-codes-for___th",
    path: qr_45codes_45forsiKtTDHadyMeta?.path ?? "/th/qr-codes-for",
    children: [],
    url: "/th/qr-codes-for",
    meta: qr_45codes_45forsiKtTDHadyMeta || {},
    alias: qr_45codes_45forsiKtTDHadyMeta?.alias || [],
    redirect: qr_45codes_45forsiKtTDHadyMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-for.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___en___default",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/qr-codes-in-education",
    children: [],
    url: "/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___en",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/en/qr-codes-in-education",
    children: [],
    url: "/en/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___vi",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/vi/qr-codes-in-education",
    children: [],
    url: "/vi/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___de",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/de/qr-codes-in-education",
    children: [],
    url: "/de/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___es",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/es/qr-codes-in-education",
    children: [],
    url: "/es/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___fr",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/fr/qr-codes-in-education",
    children: [],
    url: "/fr/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___it",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/it/qr-codes-in-education",
    children: [],
    url: "/it/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___ja",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/ja/qr-codes-in-education",
    children: [],
    url: "/ja/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___nl",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/nl/qr-codes-in-education",
    children: [],
    url: "/nl/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___pt",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/pt/qr-codes-in-education",
    children: [],
    url: "/pt/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___zh",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/zh/qr-codes-in-education",
    children: [],
    url: "/zh/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___tr",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/tr/qr-codes-in-education",
    children: [],
    url: "/tr/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___id",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/id/qr-codes-in-education",
    children: [],
    url: "/id/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___hi",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/hi/qr-codes-in-education",
    children: [],
    url: "/hi/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45educationFDYFjxWr4QMeta?.name ?? "qr-codes-in-education___th",
    path: qr_45codes_45in_45educationFDYFjxWr4QMeta?.path ?? "/th/qr-codes-in-education",
    children: [],
    url: "/th/qr-codes-in-education",
    meta: qr_45codes_45in_45educationFDYFjxWr4QMeta || {},
    alias: qr_45codes_45in_45educationFDYFjxWr4QMeta?.alias || [],
    redirect: qr_45codes_45in_45educationFDYFjxWr4QMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-education.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___en___default",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/qr-codes-in-marketing",
    children: [],
    url: "/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___en",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/en/qr-codes-in-marketing",
    children: [],
    url: "/en/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___vi",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/vi/qr-codes-in-marketing",
    children: [],
    url: "/vi/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___de",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/de/qr-codes-in-marketing",
    children: [],
    url: "/de/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___es",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/es/qr-codes-in-marketing",
    children: [],
    url: "/es/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___fr",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/fr/qr-codes-in-marketing",
    children: [],
    url: "/fr/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___it",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/it/qr-codes-in-marketing",
    children: [],
    url: "/it/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___ja",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/ja/qr-codes-in-marketing",
    children: [],
    url: "/ja/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___nl",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/nl/qr-codes-in-marketing",
    children: [],
    url: "/nl/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___pt",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/pt/qr-codes-in-marketing",
    children: [],
    url: "/pt/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___zh",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/zh/qr-codes-in-marketing",
    children: [],
    url: "/zh/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___tr",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/tr/qr-codes-in-marketing",
    children: [],
    url: "/tr/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___id",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/id/qr-codes-in-marketing",
    children: [],
    url: "/id/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___hi",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/hi/qr-codes-in-marketing",
    children: [],
    url: "/hi/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  },
  {
    name: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.name ?? "qr-codes-in-marketing___th",
    path: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.path ?? "/th/qr-codes-in-marketing",
    children: [],
    url: "/th/qr-codes-in-marketing",
    meta: qr_45codes_45in_45marketinglKuTbH5bBIMeta || {},
    alias: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.alias || [],
    redirect: qr_45codes_45in_45marketinglKuTbH5bBIMeta?.redirect || undefined,
    component: () => import("D:/App/Qrgateway.com/homepage_n3.2/pages/qr-codes-in-marketing.vue").then(m => m.default || m)
  }
]